import { GeneralHtmlSupportConfig, HeadingConfig, LinkConfig, ListConfig } from "ckeditor5";

export const defaultHTMLSupport: GeneralHtmlSupportConfig = {
  allow: [
    {
      name: "span",
      attributes: true,
      classes: true,
      styles: true,
    },
    {
      name: "img",
      attributes: true,
      classes: true,
      styles: "",
    },
  ],
};

export const defaultHeading: HeadingConfig = {
  options: [
    { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
    {
      model: "heading1",
      view: "h3",
      title: "Heading 1",
      class: "ck-heading_heading1",
    },
    {
      model: "heading2",
      view: "h4",
      title: "Heading 2",
      class: "ck-heading_heading2",
    },
  ],
};

export const defaultList: ListConfig = {
  properties: {
    styles: true,
    startIndex: true,
    reversed: true,
  },
};

export const defaultLink: LinkConfig = {
  decorators: {
    openInNewTab: {
      mode: "manual",
      label: "Open in a new tab",
      defaultValue: true,
      attributes: {
        target: "_blank",
        rel: "noopener noreferrer",
      },
    },
  },
};

